/*
 *   App Environments
 *   use this file to add, edit or delete API URL
 *
 *   @env {Object} : API URLs
 *   @hosts {Object} : list of hosts that will use this App
 */

const API_VERSION = "v2";

// API URLs related to evn
const env = {
  development: "https://api-dev.brickspms.click",

  staging: "https://api-staging.brickspms.click",
  production: "https://api.brickspms.com",
  /*
 staging: 'http://api.dev.leasing.clicksandbox.com:8080',
 production: 'http://api.pro.mbeetapp.com',
 test_production: 'http://api.test.mbeetapp.com',
 */
};

// hosts that will use this App
let hosts = {
  development: ["localhost", "admin-dev.brickspms.click"],
  staging: ["admin-staging.brickspms.click"],
  
  production: ["admin.brickspms.com"],
  /*
 staging: [, 'staging.mbeet.clicksandbox.com','staging.mbeetapp.com', '52.76.100.147', 'local.mbeet.staging'],
 production: ['pro.mbeet.clicksandbox.com','mbeetapp.com','13.229.15.225', 'pro.mbeet.clicksandbox1.com', 'local.mbeet.prod'],
 test_production: ['test.mbeetapp.com']
 */
};

let leasing = {

  development: "https://admin-dev.brickspms.click/",
  staging: "https://admin-staging.brickspms.click/",
  production: "https://brickspms.com",

};

// const hostname = window.location.hostname;
// export const current_env = Object.keys(hosts).filter((host) =>
//   hosts[host].includes(hostname)
// );
// export const API_URL =
//   current_env.length !== 0 ? env[current_env.toString()] : env.development;
// const lease = leasing[current_env[0]];

export function setEnv() {

  const hostname = window.location.hostname;
  const current_env = Object.keys(hosts).filter((host) =>
    hosts[host].includes(hostname)
  );
  const API_URL =
    current_env.length !== 0 ? env[current_env.toString()] : env.development;
  const lease = leasing[current_env[0]];
  window.api = API_URL;
  console.log(API_URL,current_env,window.api)
  window.api_version = API_VERSION;
  window.lease = lease;
}



// WEBPACK FOOTER //
// ./src/env.js